// Le aziende partner reali verranno pubblicate nella pagina /sponsor quando aderiranno.
// Nessun dato di fantasia: la vetrina resta vuota fino alle adesioni ufficiali.
export const SPONSORS = [];

export const SOCIAL = {
  instagram: "https://www.instagram.com/donnaimpresa",
  handle: "@donnaimpresa",
};

export const LOGO_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_3fe2f404-800d-42d4-b3a9-254e5e4481e7/artifacts/z6bxm53m_WhatsApp%20Image%202026-08-23%20at%2014.23.02.jpeg";
